var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3267 14.6749V14.6749C26.3267 13.0061 26.3267 12.1716 26.0832 11.5036C25.676 10.3869 24.7963 9.50713 23.6796 9.1C23.0115 8.85645 22.1771 8.85645 20.5083 8.85645H12.3849C10.716 8.85645 9.8816 8.85645 9.21355 9.1C8.09685 9.50713 7.21709 10.3869 6.80996 11.5036C6.56641 12.1716 6.56641 13.0061 6.56641 14.6749V14.6749M26.3267 14.6749V22.7791C26.3267 25.034 26.3267 26.1614 25.8879 27.0227C25.5019 27.7803 24.8859 28.3962 24.1283 28.7822C23.2671 29.221 22.1396 29.221 19.8847 29.221H13.0084C10.7535 29.221 9.62604 29.221 8.76478 28.7822C8.00719 28.3962 7.39125 27.7803 7.00524 27.0227C6.56641 26.1614 6.56641 25.034 6.56641 22.7791V14.6749M26.3267 14.6749H6.56641",
    stroke: "#3B4B53",
    strokeWidth: 2.01312
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 5.94727L11.834 11.7657M21.0555 5.94727L21.0555 11.7657",
    stroke: "#3B4B53",
    strokeWidth: 2.01312,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4473 25.583L16.4473 18.3099",
    stroke: "#3B4B53",
    strokeWidth: 2.01312,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7383 21.9463L13.1515 21.9463",
    stroke: "#3B4B53",
    strokeWidth: 2.01312,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.f9440523e62f021507bebe389ed5793a.svg";
export { ForwardRef as ReactComponent };